<template>
  <el-drawer :modal="false"  :visible.sync="drawerShowSms" title="Send SMS" class="drawer-show-sms" size="45%">
    <b-container>
      <el-tabs>
        <el-tab-pane label="Send SMS">
          <send-sms-tab :smsProfile="this.smsProfile" @getSmsHistory="getSmsHistory"/>
        </el-tab-pane>
        <el-tab-pane label="History Log">
          <history-log :sms-logs.sync="smsLogs" />
        </el-tab-pane>
      </el-tabs>
    </b-container>
  </el-drawer>
</template>
<script>
import { Drawer, Option, Select, Tabs, TabPane } from 'element-ui';
import SendSmsTab from '@/views/Sms/SendSmsTab';
import HistoryLog from '@/views/Sms/HistoryLog';
import { mapActions, mapState } from 'pinia';
import { useMessagingStore } from '@/stores/messagingStore';


export default {
  components: {
    SendSmsTab,
    HistoryLog,
    [Drawer.name]: Drawer,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
  },
  data() {
    return {
      drawerShowSms: false,
      smsLogs: [],
      smsProfile: {},
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    ...mapActions(useMessagingStore, ['getSmsLogs']),
    viewSmsDrawer(params) {
			this.drawerShowSms = !this.drawerShowSms;
      this.smsProfile = params;
      this.getSmsHistory(params);
    },
    getSmsHistory(profile) {
      const params = {
        customer_id: profile.owner_id,
      };
			console.log(params);
      this.getSmsLogs(params).then(resp => {
        this.smsLogs = resp;
      });
    }
  }
}
</script>